// Central typography configuration for Mini-PLM
// All font changes should be made here only

const typography = {
  // Primary UI font � used everywhere in the app
  primary: "'Roboto', 'Segoe UI', 'Arial', sans-serif",

  // Monospace font � used in code blocks and ASCII diagrams
  mono: "'Consolas', 'Courier New', 'DejaVu Sans Mono', monospace",

  size: {
    xs: '0.75rem',
    sm: '0.85rem',
    md: '13px',
    lg: '1rem',
    xl: '1.25rem',
  },

  lineHeight: {
    normal: '1.5',
    code: '1.4',
  },
};

export default typography;
